import { ColumnDef } from '@tanstack/react-table';
import { TextLinkButton } from 'components/buttons/TextLinkButton';
import { IndeterminateCheckbox } from 'components/tables/IndeterminateCheckbox';
import { Color } from 'core';
import styled from 'styled-components';

export const BulkActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: ${Color.primaryGray};
  border-radius: 4px;
  margin: 12px 0;
`;

export const SelectionCount = styled.span`
  font-weight: 500;
  color: ${Color.primaryBlack};
`;

export const DeselectButton = styled(TextLinkButton)`
  padding: 8px;
`;

export const CheckboxCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const createSelectionColumn = <T,>(): ColumnDef<T> => ({
  id: 'select',
  header: ({ table }) => (
    <CheckboxCell>
      <IndeterminateCheckbox
        checked={table.getIsAllPageRowsSelected()}
        indeterminate={table.getIsSomePageRowsSelected()}
        onChange={table.getToggleAllPageRowsSelectedHandler()}
      />
    </CheckboxCell>
  ),
  cell: ({ row }) => (
    <CheckboxCell>
      <IndeterminateCheckbox checked={row.getIsSelected()} onChange={row.getToggleSelectedHandler()} />
    </CheckboxCell>
  ),
});
